import React from "react";
import getConfig from "next/config";
import { resizeImage } from "@lib/helpers";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const Image = React.memo(function Image({ src, className, name }) {
  return <img src={src} className={className} alt={name} />;
});

const ProductListImage = ({ thumbnail, name }) => (
  <Image
    src={resizeImage(thumbnail, "300x300")}
    alt=""
    name={name}
    className={isBricoStore ? "rounded-t-[8px]" : undefined}
  />
);

export default ProductListImage;
